module.exports = __webpack_public_path__ + "static/media/296.31f5334f.wav";